const DRIVE = "https://lh3.googleusercontent.com/d/";
const DRIVE_FILE = "https://drive.google.com/file/d/";

export const HOW_TO_VIDEO = {
  id: "1jpR8ml1TUaRlwtcOoafKz7ysM5046ocI",
  name: "How to navigate this library",
  note: "Skip to 0:40 for the walkthrough",
};

export const EDUCATION_SECTIONS = [
  {
    key: "young",
    title: "Brookside & Young Audiences",
    blurb: "Short, friendly introductions made for our youngest naturalists.",
    items: [
      {
        id: "1xsKWVrQ4usP_XMLta5bv4yXCEloUx87a",
        name: "Pollination 101 — Brookside Intro to Pollinators",
        type: "video",
        tag: "Insects",
      },
      {
        id: "1-zLX2lKuZWiQ25k_jpn0qkd9keIk5b1h",
        name: "PSA — Bees & Wasps: Identification and How to Tell the Difference",
        type: "pdf",
        tag: "Insects",
      },
    ],
  },
  {
    key: "older",
    title: "MS, HS & Adult Audiences",
    blurb: "Deeper dives into campus ecosystems and conservation work.",
    items: [
      {
        id: "1Qr1YcmZWx4n2UUOSXyju8MDnf31airRt",
        name: "CK Critters EP 1 — Pollinators",
        type: "video",
        tag: "Insects",
      },
      {
        id: "1mZ-Q1k06vAmvZwOYauuQoMZWsvZNTR58",
        name: "Save Our Wetlands — Ecosystem Education",
        type: "video",
        tag: "Ecosystem & Conservation",
      },
      {
        id: "1t8Ntww6XSmo8isRKRolph949oTvuNbyb",
        name: "PSA — Bees & Wasps: Identification and How to Tell the Difference",
        type: "pdf",
        tag: "Insects",
      },
    ],
  },
];

export const eduThumb = (id) => `${DRIVE}${id}=w800`;
export const eduPlayerUrl = (id) => `${DRIVE_FILE}${id}/preview`;
export const eduViewUrl = (id) => `${DRIVE_FILE}${id}/view`;
